import global from './global';
// PAGES
import { atlas } from './pages/atlas';
import { blog } from './pages/blog';
import { errorPage } from './pages/error-page';
import { glossary } from './pages/glossary';
import { login } from './pages/login';
import { phoneVerification } from './pages/phone-verification';
import { estimateEmailSent } from './pages/estimate-email-sent';
import { brokerHandover } from './pages/broker-handover';
import { estimateSubscribedContact } from './pages/estimate-subscribed-contact';
import { estateDashboardMessages } from './pages/estate-dashboard';
import { adEstate } from './pages/ad-estate';
import { atlasAdCatalog } from './pages/atlas-ad-catalog';
import { estimateLandingPage } from './pages/estimate-landing-page';
// Modules
import { survey as surveyModule } from './modules/survey';
import { updateEmailModal } from './modules/update-email-modal';

export const cs = {
  ...atlas,
  ...blog,
  ...errorPage,
  ...errorPage,
  ...global,
  ...glossary,
  ...login,
  ...surveyModule,
  ...phoneVerification,
  ...estimateEmailSent,
  ...brokerHandover,
  ...estimateSubscribedContact,
  ...estateDashboardMessages,
  ...adEstate,
  ...atlasAdCatalog,
  ...estimateLandingPage,
  ...updateEmailModal,
};
